import { RouteRecordRaw } from 'vue-router';

const guestRoutes: Array<RouteRecordRaw> = [
    {
        path: '/404',
        name: 'notFound',
        component: () => import('../views/not-found/NotFound.vue'),
        meta: { guest: true },
        props: false
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: () => import('../views/home/Maintenance.vue'),
        meta: { guest: true },
        props: false
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/LoginPage.vue'),
        meta: { guest: true },
        props: false
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/auth/RegisterPage.vue'),
        meta: { guest: true },
        props: false
    },
    {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: () => import('../views/auth/ForgotPasswordPage.vue'),
        meta: { guest: true },
        props: false
    },
    {
        path: '/reset-password/:token',
        name: 'resetPassword',
        component: () => import('../views/auth/ResetPasswordPage.vue'),
        meta: { guest: true },
        props: true
    },
    {
        path: '/:previewCode?',
        name: 'home',
        component: () => {
            return import('../views/home/HomePage.vue');
        },
        meta: { guest: true },
        props: true
    }
];

export default guestRoutes;
